<div class="user-menu">

  <!-- Trigger: circular avatar + name + chevron -->
  <button type="button"
          class="user"
          [class.user--open]="isOpen()"
          aria-haspopup="menu"
          [attr.aria-expanded]="isOpen()"
          aria-controls="user-profile-menu"
          (click)="toggle()"
          (keydown)="onTriggerKeydown($event)">
    <span class="user__avatar" aria-hidden="true">
      <img class="user__avatar-img" [src]="avatarUrl()" (error)="onImgError($event)" alt="" />
    </span>
    @if (userName()) {
      <span class="user__name">{{ userName() }}</span>
    } @else {
      <span class="user__name-shimmer" aria-hidden="true"></span>
    }
    <span class="user__chev" aria-hidden="true">
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L9 1" stroke="#3D3D3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </button>

  <!-- Dropdown panel -->
  @if (isOpen()) {
    <div id="user-profile-menu"
         class="menu"
         role="menu"
         [attr.aria-label]="'profile.menuAriaLabel' | translate"
         (keydown)="onMenuKeydown($event)">

      @for (item of items; track item.id; let i = $index) {
        <button #menuItem
                type="button"
                class="menu__item"
                role="menuitem"
                [tabindex]="i === activeIndex() ? 0 : -1"
                (click)="onSelect(item)">
          <span class="menu__item-label">{{ item.text | translate }}</span>
        </button>
      }

      <!-- Non-clickable, greyed-out version label (divided from items by a top border) -->
      <span class="menu__version" role="menuitem" aria-disabled="true">
        {{ version }}
      </span>
    </div>
  }
</div>
